 
export const companies = [
  {
    src: "/companies/remocapp.svg",
    alt: "remocapp",
  },
  {
    src: "/companies/iqms.svg",
    alt: "iqms",
  },
  {
    src:  "/companies/bounty.svg",
    alt: "Bounty",
  },
  {
    src:  "/companies/humm.svg",
    alt: "Humm",
  },
  {
    src:  "/companies/fuplace.svg",
    alt: "Fuplace",
  },
  {
    src:  "/companies/express.svg",
    alt: "Express",
  },
];
